/** AY custom dimension carrying `<targetingKey>-<typeTag6>`, withheld until identifier consent. */
export const USER_ID_DIMENSION = 'custom_8'

/** AY custom dimension naming the provider that resolved the HEM. */
export const HEM_PROVIDER_DIMENSION = 'custom_13'

/** AY custom dimension carrying the raw consent state for reporting splits. */
export const CONSENT_STATE_DIMENSION = 'custom_15'
